module.exports = __webpack_public_path__ + "media/images/illustrations/bg-noise-5b43a87580f5ea5f940b44fde02ba37f.jpg";